import React, { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faSync, faCheck } from "@fortawesome/free-solid-svg-icons"
import {
	putInventaireConsommation,
	putInventaireConsommationReset,
	deleteInventaireConsommation,
	deleteInventaireConsommationReset,
} from "../../../store/actions/atelierInventaireActions"
import { COLORS } from "../../../utilities/Constants"
import CustomModal from "../../basics/interface/CustomModal"

// Édition d'une consommation de stock virtuel (correction d'erreur) : quantité
// + type (consommable). La suppression restaure le stock. Le back ajuste
// quantite_utilisee et borne la quantité ; ici on cape aussi côté UI.
const ConsommationModalV2 = ({ consommation, consommables, onClose }) => {
	const dispatch = useDispatch()
	const putState = useSelector((s) => s.atelierInventaire.putConsommation)
	const deleteState = useSelector(
		(s) => s.atelierInventaire.deleteConsommation,
	)
	const [confirmDelete, setConfirmDelete] = useState(false)
	const [quantite, setQuantite] = useState(String(consommation.quantite))
	const [consommable, setConsommable] = useState(
		consommation.consommable || 0,
	)

	// Max = stock encore dispo + la quantité déjà consommée par cette ligne
	// (qu'on libère si on la réduit).
	const max = (consommation.article_dispo || 0) + consommation.quantite

	useEffect(() => {
		if (!putState.saved && !deleteState.deleted) return
		const t = setTimeout(() => {
			dispatch(putInventaireConsommationReset())
			dispatch(deleteInventaireConsommationReset())
			onClose()
		}, 800)
		return () => clearTimeout(t)
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [putState.saved, deleteState.deleted])

	useEffect(
		() => () => {
			dispatch(putInventaireConsommationReset())
			dispatch(deleteInventaireConsommationReset())
		},
		// eslint-disable-next-line react-hooks/exhaustive-deps
		[],
	)

	const setQte = (value) => {
		if (value !== "" && parseInt(value) > max) setQuantite(String(max))
		else setQuantite(value)
	}

	const invalid =
		["", "0", 0].includes(quantite) || consommable === 0

	const save = () =>
		dispatch(
			putInventaireConsommation(
				JSON.stringify({
					id: consommation.id,
					quantite: parseInt(quantite),
					consommable,
					// Liste à rafraîchir = celle du consommable affiché (celui
					// d'origine de la ligne), pas le nouveau type éventuel.
					viewConsommable: consommation.consommable,
				}),
			),
		)
	const remove = () => {
		if (!confirmDelete) {
			setConfirmDelete(true)
			return
		}
		dispatch(
			deleteInventaireConsommation(
				JSON.stringify({ id: consommation.id }),
			),
		)
	}

	const busy =
		putState.saving ||
		putState.saved ||
		deleteState.deleting ||
		deleteState.deleted

	const buttons = [
		{
			title: deleteState.deleting ? (
				<FontAwesomeIcon icon={faSync} spin />
			) : confirmDelete ? (
				"Confirmer ?"
			) : (
				"Supprimer"
			),
			styleName: "danger",
			onClick: remove,
			disabled: busy,
		},
		{
			title: "Annuler",
			styleName: "secondary",
			onClick: onClose,
			disabled: busy,
		},
		{
			title: putState.saving ? (
				<FontAwesomeIcon icon={faSync} spin />
			) : putState.saved ? (
				<FontAwesomeIcon icon={faCheck} />
			) : (
				"Enregistrer"
			),
			styleName: "primary",
			onClick: save,
			disabled: busy || invalid,
		},
	]

	return (
		<CustomModal
			title="Modifier la consommation"
			subtitle={consommation.article_label}
			onClose={busy ? () => {} : onClose}
			showCloseButton={!busy}
			buttons={buttons}
		>
			<div style={s.field}>
				<span style={s.label}>Type</span>
				<select
					style={s.input}
					value={consommable}
					onChange={(e) => setConsommable(parseInt(e.target.value))}
				>
					<option value={0}>-</option>
					{consommables.map((c) => (
						<option key={c.id} value={c.id}>
							{c.label}
						</option>
					))}
				</select>
			</div>
			<div style={s.field}>
				<span style={s.label}>Quantité (max {max})</span>
				<input
					type="number"
					style={s.input}
					value={quantite}
					onFocus={(e) => e.target.select()}
					onChange={(e) => setQte(e.target.value)}
				/>
			</div>
		</CustomModal>
	)
}

const s = {
	field: { display: "flex", flexDirection: "column", marginBottom: 14 },
	label: {
		fontSize: 12,
		fontWeight: 600,
		color: COLORS.textMuted,
		marginBottom: 6,
	},
	input: {
		height: 38,
		padding: "0 12px",
		borderRadius: 10,
		border: `1px solid ${COLORS.border}`,
		fontSize: 14,
		color: COLORS.text,
		fontFamily: "inherit",
		backgroundColor: COLORS.surface,
		boxSizing: "border-box",
	},
}

export default ConsommationModalV2
